/**
 * Integrytas Group - Base App (MOBILE)
 * "Desktop Version Required" modal — shown when a user taps a menu item whose
 * effective desktop_only flag is set (§ task phase 4/5). The underlying route is
 * left intact; this only intercepts the tap.
 *
 * Slate-and-Steel: crisp #E5E7EB border, clean white container, backdrop blur,
 * a primary-blue (#00529B) header with a monitor/phone icon, bold title, and a
 * single primary "Understood" action. Styles live in mobile.css (.m-dtm-*).
 */

import { useTranslation } from 'react-i18next';
import { MonitorSmartphone } from 'lucide-react';

export interface DesktopOnlyModalProps {
  open: boolean;
  /** Optional page label, woven into the copy for context. */
  pageTitle?: string;
  onDismiss: () => void;
}

export function DesktopOnlyModal({ open, pageTitle, onDismiss }: DesktopOnlyModalProps) {
  const { t } = useTranslation();
  const lead = pageTitle ? `“${pageTitle}” — ` : '';
  return (
    <div className={'m-dtm-scrim' + (open ? ' m-open' : '')} onClick={onDismiss}>
      <div
        className="m-dtm"
        role="dialog"
        aria-modal="true"
        aria-label={t('mobile.desktop_only.title', 'Desktop Version Required')}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="m-dtm-head">
          <span className="m-dtm-ic"><MonitorSmartphone /></span>
          <span className="m-dtm-title">{t('mobile.desktop_only.title', 'Desktop Version Required')}</span>
        </div>
        <div className="m-dtm-body">
          <p>
            {lead}
            {t('mobile.desktop_only.body', 'This feature requires advanced system resources or formatting optimized for the desktop environment. Please use the desktop version for this option.')}
          </p>
        </div>
        <div className="m-dtm-foot">
          <button type="button" className="m-dtm-btn" onClick={onDismiss} autoFocus>
            {t('mobile.desktop_only.dismiss', 'Understood')}
          </button>
        </div>
      </div>
    </div>
  );
}
